/******************************************************************************\
 * :$
 *
 * Copyright(c) 2021 SAS Institute Inc., Cary, NC, USA. All Rights Reserved.
 *
 * Name: IUser
 *
 * Purpose: user interface
 *
 * Author: craig (Craig.Simpson@sas.com)
 *
 * Support: SAS(r) Solutions OnDemand
 *
 * Input:
 *
 * Output:
 *
 * Parameters: (if applicable)
 *
 * Dependencies/Assumptions:
 *
 * Usage:
 *
 * History:
 * ddmmmyyyy userid description (Change Code)
 * 06Dec2021 craig File created.
 \******************************************************************************/
import {ITeamUserLinkage, ITeamUserSubmissionLinkage} from "../application/IApplication";

export enum RoleEnum {
    Guest = 1,
    Reviewer,
    GS_Admin,
    Admin
}

export interface IRole {
    RoleID: RoleEnum,
    Role: string
}

export interface IUser {
    UserID: number,
    //Name: string,
    FirstName: string,
    LastName: string,
    EmailAddress: string,
    //Username: string,
    PhoneNumber: string,
    Title: string,
    Organization: string,
    RoleID: RoleEnum,
    Role: IRole,
    Attested: boolean,
    Authenticated: boolean,
    LoginMsg?: string,
    TeamUserLinkage?: ITeamUserLinkage[],
    TeamUserSubmissionLinkage?: Map<number,ITeamUserSubmissionLinkage>
}